
export enum TipoContaBancariaEnum {
  ContaCorrente = 'ContaCorrente',
  Poupanca = 'Poupanca',
  Salario = 'Salario',
}
